/**
 * Customized font sizes.
 *
 * Reference: https://chakra-ui.com/docs/theming/theme
 */

const fontSizes = {
  xxs: '11px',
  xs: '13px',
  sm: '15px',
  md: '16px',
  lg: '18px',
  xl: '20px',
  xxl: '24px',
  '3xl': '32px',
  '4xl': '40px',
  '5xl': '48px',
  '6xl': '56px',
  '7xl': '64px',
  '8xl': '72px'
};

export default fontSizes;
